import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';
import { cloneDeep } from 'lodash';

import { UpdateOrderModel } from '../../order/models/update-order-model';
import { UpdateOrderDialogComponent } from '../../order/update/update-order-dialog/update-order-dialog.component';

@Component({
  selector: 'app-freetext-icon',
  templateUrl: './freetext-icon.component.html',
  standalone: false,
})
export class FreetextIconComponent implements OnInit {
  dialog = inject(MatDialog);

  @Input() public linkedFullTextCount = 0;
  @Input() public disabled = false;
  @Input() public order!: Order;
  public updateOrderModel: UpdateOrderModel = {};
  ngOnInit(): void {
    this.updateOrderModel.order = cloneDeep(this.order);
    this.updateOrderModel.originalOrder = cloneDeep(this.order);
  }
  openDialog(): void {
    if (!this.disabled) {
      this.dialog.open(UpdateOrderDialogComponent, {
        data: { model: this.updateOrderModel, focusTabIndex: 3 },
        height: '85vh',
        width: '70vw',
        position: { top: '4rem' },
        disableClose: true,
      });
    }
  }
}
